import React from 'react';
import { FaStarAndCrescent } from 'react-icons/fa';

const EidMubarak = () => {
  return (
    <div className="bg-gradient-to-b from-red-900 to-black py-8 px-4 sm:px-6 lg:px-8 flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-r from-b-500 to-red-500 opacity-50 transform rotate-45"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-a-500 to-b-500 opacity-50 transform -rotate-45"></div>
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 bg-repeat bg-center bg-starry-pattern opacity-20"></div>
      </div>
      <div className="relative z-10 text-center">
        <div className="flex items-center justify-center mb-8">
          <div className="relative">
            <FaStarAndCrescent className="text-white text-6xl sm:text-7xl lg:text-8xl transform -rotate-45 drop-shadow-lg" />

          </div>
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg animate-sparkle">
          Eid Mubarak!
        </h1>
        <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-6 drop-shadow-lg animate-sparkle">
          Enjoy 14.46% Discount on everything
        </h1>
        <div className="absolute inset-0 pointer-events-none">
          <div className="sparkle"></div>
          <div className="sparkle"></div>
          <div className="sparkle"></div>
          <div className="sparkle"></div>
          <div className="sparkle"></div>
        </div>
      </div>
    </div>
  );
};

export default EidMubarak;